varying vec3 vColor;
varying float vAlpha;

void main() {
  vec2 center = gl_PointCoord - vec2(0.5);
  float dist = length(center);
  if (dist > 0.5) discard;

  // Soft glow — bright core fading to halo
  float glow = 1.0 - smoothstep(0.0, 0.5, dist);
  float core = smoothstep(0.25, 0.0, dist);
  glow = pow(glow, 1.8);

  float alpha = glow * vAlpha;

  // Hot white core bleeding into channel color
  vec3 color = mix(vColor, vec3(1.0), core * 0.6);

  gl_FragColor = vec4(color * (1.0 + glow * 0.4), alpha);
}
